import React from "react";
import { Box, Skeleton, SxProps, Theme } from "@mui/material";
import { useAuthenticatedFileUrl } from "../../hooks/useAuthenticatedFileUrl";

type AuthenticatedImageProps = {
  src?: string | null;
  alt?: string;
  sx?: SxProps<Theme>;
  onClick?: React.MouseEventHandler<HTMLImageElement>;
  onLoad?: React.ReactEventHandler<HTMLImageElement>;
  onError?: React.ReactEventHandler<HTMLImageElement>;
};

export const AuthenticatedImage: React.FC<AuthenticatedImageProps> = ({
  src,
  alt = "",
  sx,
  onClick,
  onLoad,
  onError,
}) => {
  const { url, isLoading } = useAuthenticatedFileUrl(src ?? undefined);

  if (!src) return null;

  if (isLoading || !url) {
    return (
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          width: "100%",
          minHeight: 120,
          borderRadius: 1,
          ...sx,
        }}
      />
    );
  }

  return (
    <Box
      component="img"
      src={url}
      alt={alt}
      sx={sx}
      onClick={onClick}
      onLoad={onLoad}
      onError={onError}
    />
  );
};
